<!--Copyright (c) PikPok. All rights reserved-->
<template>
  <v-app>
    <v-app-bar app class="pt-3 pb-3">
      <v-spacer/>
      <v-app-bar-title>
        <router-link to="/">
          <v-img src="./assets/pikpok_logo.png" height="60"/>
        </router-link>
      </v-app-bar-title>
      <v-spacer/>
    </v-app-bar>

    <v-main class="overflow-hidden">
      <v-spacer></v-spacer>
      <v-img class="mt-5 cover-image" src="./assets/corporate_deck_news_item_3200x532_01.jpg" :cover="true"></v-img>
      <router-view></router-view>
    </v-main>

    <v-footer app class="bg-yellow-darken-3 pl-0 pr-0">
      <v-row style="text-align: center">
        <v-col cols="12" class="pt-2 pb-2">
          <v-btn
              :href="icon.link" target="_blank"
              v-for="icon in icons"
              :key="icon.icon"
              :icon="icon.icon"
              variant="text"
              density="compact"
              feb
              color="white">
          </v-btn>
        </v-col>
        <v-col cols="12" class="text-white pt-1">&copy; 2023 Customer Support Theme. All Rights Reserved.</v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        {icon: 'mdi-facebook', link: 'https://www.facebook.com/pikpokgames/'},
        {icon: 'mdi-twitter', link: 'https://twitter.com/PikPokGames/'},
        {icon: 'mdi-instagram', link: 'https://www.instagram.com/pikpokofficial/'},
        {icon: 'mdi-youtube', link: 'https://www.youtube.com/user/pikpokgames'}
      ],

    };
  },
  methods: {}
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Noto+Sans');

html {
  overflow-y: auto !important;
  font-family: "Open Sans", sans-serif !important;
}

h3 {
  font-family: "Noto Sans", sans-serif !important;
  font-size: 1.04rem !important;
}

h2 {
  font-family: "Noto Sans", sans-serif !important;
}

.flex-grow-1 {
  display: none;
}

.cover-image {
  max-height: 350px;
}

@media only screen and (max-width: 2000px) {
  .cover-image {
    max-height: 250px;
  }
}

router-link {
  text-decoration: none;
  color: inherit;
}

a {
  text-decoration: none;
  color: inherit;
}
</style>
